export enum DigitalShareItemType {
  //Common
  Children = "Children",
  Marriage = "Marriage",
  NumberOfPersons = "# of Persons in Household",
  HeadOfHouseholdAge = "Head of Household Age",
  RaceAndEthnicity = "Race and Ethnicity",
  HouseholdIncome = "Household Income",
  HouseholdEducationLevel = "Household Education Level",
  DwellingType = "Dwelling Type",
  HomeOwnership = "Home Ownership",
  PsychographicProfile = "Psychographic Profiles",
  PsychographicSummary = "Psychographic Summary",
  //Retail Match
  KeyMetrics = "Key Metrics",
  ImageGallery = "Image Gallery",
  LocationsAnalyzed = "Locations Analyzed",
  BrandComparison = "Brand Comparison",
  //GPS
  VisitorMap = "Visitor Map",
  VisitorTradeArea = "Visitor Trade Area",
  VisitorOrigination = "Visitor Origination",
  KeyProfileAttributes = "Key Profile Attributes",
  NewHomeOwner = "New Homeowner",
  NewMover = "New Mover",
  RelativeVolume = "Relative Volume Metric",
  VolumeByWeek = "Visit Volume Trend by Week",
  VolumeByDayOfWeek = "Visit Volume by Day of Week",
  VolumeByDay = "Visit Volume by Day",
  VolumeByMetrics = "Volume Metrics",
  FrequentlyVisitedPlaces = "Frequently Visited Places",
  FrequentlyVisitedPlacesMap = "Frequently Visited Places Map",
  VisitorLoyalty = "Visitor Loyalty",
  VisitorActivity = "Visitor Activity",
  VolumeByHourOfDay = "Visit Volume by Hour of Day",
}
